<template>
  <v-dialog v-model="showDialog" persistent transition="dialog-transition" max-width="450">
    <v-card>
      <v-card-title class="title">Timeline For Analysis</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-menu
              v-model="fromDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  label="From Date"
                  color="primary darken-4"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="fromDate" @input="setDateFrom"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6">
            <v-menu
              ref="fromTMenu"
              v-model="fromTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="fromTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromTime"
                  label="From Time"
                  prepend-icon="mdi-clock-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  color="primary darken-4"
                  outlined
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="fromTimeMenu"
                v-model="fromTime"
                full-width
                @click:minute="$refs.fromTMenu.save(fromTime)"
                @input="setTimeFrom"
                format="24hr"
                :max="toTime"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-menu
              v-model="toMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  label="To Date"
                  color="primary darken-4"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="toDate" @input="setDateTo"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6">
            <v-menu
              ref="toTMenu"
              v-model="toTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="toTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toTime"
                  label="To Time"
                  prepend-icon="mdi-clock-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  color="primary darken-4"
                  outlined
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="toTimeMenu"
                v-model="toTime"
                full-width
                @click:minute="$refs.toTMenu.save(toTime)"
                @input="setTimeTo"
                format="24hr"
                :min="fromTime"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text color="primary darken-4" @click="closeDialog()">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditGroupTimelineDialog",
  data() {
    return {
      fromDate: new Date().toISOString().substr(0, 10),
      fromDateMenu: false,
      fromTimeMenu: false,
      fromTime: "00:00",

      toDate: new Date().toISOString().substr(0, 10),
      toMenu: false,
      toTimeMenu: false,
      toTime: "23:59"
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setEditGroupTimelineDialog", false);
    },

    setDateFrom(value) {
      this.$store.commit("setGroupTimelineDateFrom", value);
      this.fromDateMenu = false;
    },

    setTimeFrom(value) {
      this.$store.commit("setGroupTimelineTimeFrom", value);
    },

    setDateTo(value) {
      this.$store.commit("setGroupTimelineDateTo", value);
      this.toMenu = false;
    },

    setTimeTo(value) {
      this.$store.commit("setGroupTimelineTimeTo", value);
    }
  },

  watch: {},

  mounted() {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.editGroupTimelineDialog;
    }
  }
};
</script>

<style>
</style>